import React, { useRef, useState } from "react";
import { message, Button, Form, Input, Row, Col, Modal, Upload } from "antd";
import { addCategory } from "../../../ApiServices/Apifun";
import { IoCloudUploadOutline } from "react-icons/io5";
import { dispatchtoast } from "../../../utils";

const AddCategory = ({
  isOpen,
  setIsOpen,
  from,
  Fill,
  addingCategory,
  addSubcategory,
}) => {
  const [form] = Form.useForm();
  const [image, setImage] = useState([]);
  const [imageBase64, setImageBase64] = useState(false);
  const formRef = useRef(form);
  console.log(image);
  const createCategory = (changedValues) => {

    const formdata = new FormData();
    formdata.append("category_name", changedValues.categoryName);
    image.map(i => formdata.append("images", i))

    addCategory(formdata)
      .then((response) => {
        if (response.status) {
         dispatchtoast(response.message)
            setIsOpen(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        createCategory(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };
  const handleCustomReq = async ({ file, onSuccess, onError }) => {
    console.log(file);
    setImage([file]);
    // try {
    //   const base64Data = await readFileAsBase64(file);
    //   const dataUrl = await readFileAsDataUrl(file);
    //   const newFile = {
    //     ...file,

    //   };

    //   setImageBase64(base64Data);
    //   onSuccess();
    // } catch (error) {
    //   console.error(error);
    //   onError(error);
    // }
  };
  const readFileAsDataUrl = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };
  // Helper function to read a file as Base64 data
  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result; // Remove the data URI prefix
        resolve(base64Data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };
  return (
    <Modal
      footer={null}
      visible={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title={"Add Category"}
    >
      <Form
        className="bg-white p-6"
        layout="vertical"
        onFinishFailed={(err) => console.log(err)}
        onFinish={createCategory}
        form={form}
        ref={formRef}
      >
   
     
            <Form.Item
              name="categoryName"
              label={"Add Category"}
              rules={[
                {
                  required: true,
                  message: "Please enter category",
                },
                {
                  message: "Please enter a valid category name",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={`images`}
              label={"Category Image"}
              className="w-full"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Upload one Category Image!",
                },
              ]}
            >
              <Upload
                maxCount={1}
                onRemove={() => {
                  setImage([])
                }}
                listType="picture"
                accept=".jpg, .jpeg, .png"
                fileList={image}
                customRequest={handleCustomReq}
              >
                <Button
                  className="bg-primary text-white border-none font-medium"
                  icon={<IoCloudUploadOutline />}
                >
                  Click to Upload
                </Button>
              </Upload>
            </Form.Item>


        <div>
          <Form.Item className="flex mt-4">
            <Button type="primary" htmlType="submit">
              Create
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddCategory;
